import useNewMealXlsContext from './context';
('./context');
import NewMealXlsProvider from './provider';

export { NewMealXlsProvider };
export default useNewMealXlsContext;
